var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { colors, fontSizes, fontWeights } from '../styleConstants';
// Size variants
var bigButtonStyles = "\n    height: 60px;\n    min-height: 60px;\n    min-width: 60px;\n    border-radius: 10px;\n    gap: 14px;\n    padding: 0px 20px;\n";
var smallButtonStyles = "\n    height: 36px;\n    min-height: 36px;\n    min-width: 36px;\n    border-radius: 7px;\n    gap: 6px;\n    padding: 0px 9px;\n";
// Color variants
function darkButtonStyles(theme) {
    return "\n    background: ".concat(theme.colors.buttons.secondary, ";\n    color: ").concat(colors.trueWhite, ";\n");
}
function lightButtonStyles(theme) {
    return "\n    background: ".concat(theme.colors.backgrounds.app, ";\n    color: ").concat(theme.colors.text.primary, ";\n    outline: 1px solid ").concat(theme.colors.text.primary, ";\n");
}
function whiteButtonStyles(theme) {
    return "\n    background: ".concat(colors.primaryWhite, ";\n    color: ").concat(theme.colors.buttons.accent, ";\n");
}
function brandButtonStyles(theme) {
    return "\n    background: ".concat(theme.colors.buttons.primary, ";\n    color: ").concat(colors.trueWhite, ";\n");
}
function accentButtonStyles(theme) {
    return "\n    background: ".concat(theme.colors.buttons.accent, ";\n    color: ").concat(colors.trueWhite, ";\n");
}
var redButtonStyles = "\n    background: ".concat(colors.accentRed, ";\n    color: ").concat(colors.trueWhite, ";\n");
// White buttons need special gradient text
export var ButtonText = styled.h3(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: 'Outfit',\n    ", ";\n"], ["\n  font-family: 'Outfit',\n    ", ";\n"])), function (p) {
    return p.colorVariant === 'white' &&
        "\n      color: ".concat(colors.trueBlack, ";\n      background: ").concat(p.theme.colors.buttons.primary, ";\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n    ");
});
// Very flexible button component
export var StyledButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /* Container properties */\n  display: flex;\n  flex-flow: row;\n  align-items: center;\n  justify-content: ", ";\n\n  /* Sizing */\n  width: ", "; // fit-content by default\n  font-size: ", ";\n  ", " /* Coloring */ border: none;\n  ", ";\n\n  /* Text Styling */\n  font-family: 'Outfit';\n  font-size: ", ";\n  font-weight: ", ";\n\n  /* Icon positioning */\n  flex-direction: ", ";\n\n  /* Disabled variant */\n  ", "\n\n  /* Hover variant */ \n  ", "\n"], ["\n  /* Container properties */\n  display: flex;\n  flex-flow: row;\n  align-items: center;\n  justify-content: ", ";\n\n  /* Sizing */\n  width: ", "; // fit-content by default\n  font-size: ", ";\n  ", " /* Coloring */ border: none;\n  ", ";\n\n  /* Text Styling */\n  font-family: 'Outfit';\n  font-size: ", ";\n  font-weight: ", ";\n\n  /* Icon positioning */\n  flex-direction: ", ";\n\n  /* Disabled variant */\n  ", "\n\n  /* Hover variant */ \n  ", "\n"])), function (p) { return (p.oneItemOnly ? 'center' : 'space-between'); }, function (p) { return p.width; }, fontSizes.medium, function (p) {
    switch (p.sizeVariant) {
        case 'big':
            return bigButtonStyles;
        case 'small':
            return smallButtonStyles;
        default:
            return smallButtonStyles;
    }
}, function (p) {
    switch (p.colorVariant) {
        case 'dark':
            return darkButtonStyles(p.theme);
        case 'light':
            return lightButtonStyles(p.theme);
        case 'brand':
            return brandButtonStyles(p.theme);
        case 'accent':
            return accentButtonStyles(p.theme);
        case 'red':
            return redButtonStyles;
        case 'white':
            return whiteButtonStyles(p.theme);
        default:
            return darkButtonStyles(p.theme);
    }
}, fontSizes.medium, fontWeights.bold, function (p) { return (p.iconRight ? 'row-reverse' : 'row'); }, function (p) {
    if (p.disabled) {
        if (p.colorVariant === 'light') {
            // Disabled light buttons are rendered with greyed-out text
            return "\n                color: ".concat(colors.primaryGreyMediumLight, ";\n                outline: none;\n            ");
        }
        // Other disabled buttons are rendered at partial opacity
        return "\n                opacity: 0.4;\n            ";
    }
    return ''; // Non-disabled buttons get nothing
}, function (p) {
    return !p.disabled &&
        "&:hover {\n    filter: brightness(75%);\n    transition: 0.2s;\n  }";
});
var templateObject_1, templateObject_2;
